import { render } from "./PatientCallingModal.vue?vue&type=template&id=686bac33&scoped=true"
import script from "./PatientCallingModal.vue?vue&type=script&lang=js"
export * from "./PatientCallingModal.vue?vue&type=script&lang=js"

import "./PatientCallingModal.vue?vue&type=style&index=0&id=686bac33&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-686bac33"]])

export default __exports__